<!--sort_up_48dp_FILL1_wght400_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px">
    <path d="m200-560 280-280 280 280zm133-55h294l-147-147zm-133 215h560l-280 280z"/>
  </svg>
</template>
